<template>
    <b-row class="text-white" :class="{'mb-1': isExport }">
        <b-col class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4">
            <div
                class="analytics-widget-mini rounded d-flex align-items-center"
                :class="{ shadow: !isExport }"
                style="background-color: #23b7e5"
            >
                <div class="flex-shrink-1 darken-20 p-full">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="64"
                        height="36"
                        viewBox="0 0 172 172"
                        style="fill: #000000"
                    >
                        <g
                            fill="none"
                            fill-rule="nonzero"
                            stroke="none"
                            stroke-width="1"
                            stroke-linecap="butt"
                            stroke-linejoin="miter"
                            stroke-miterlimit="10"
                            stroke-dasharray=""
                            stroke-dashoffset="0"
                            font-family="none"
                            font-weight="none"
                            font-size="none"
                            text-anchor="none"
                            style="mix-blend-mode: normal"
                        >
                            <path d="M0,172v-172h172v172z" fill="none"></path>
                            <g fill="#ffffff">
                                <path
                                    d="M50.16667,62.70833c0,-8.90458 -7.22042,-16.125 -16.125,-16.125c-8.90458,0 -16.125,7.22042 -16.125,16.125c0,6.76175 0,72.068 0,78.83333c0,8.90458 7.22042,16.125 16.125,16.125c8.90458,0 16.125,-7.22042 16.125,-16.125c0,-6.76533 0,-72.07158 0,-78.83333zM154.08333,30.45833c0,-8.90458 -7.22042,-16.125 -16.125,-16.125c-8.90458,0 -16.125,7.22042 -16.125,16.125c0,6.76175 0,104.318 0,111.08333c0,8.90458 7.22042,16.125 16.125,16.125c8.90458,0 16.125,-7.22042 16.125,-16.125c0,-6.76533 0,-104.32158 0,-111.08333zM102.125,94.95833c0,-8.90458 -7.22042,-16.125 -16.125,-16.125c-8.90458,0 -16.125,7.22042 -16.125,16.125c0,6.76175 0,39.818 0,46.58333c0,8.90458 7.22042,16.125 16.125,16.125c8.90458,0 16.125,-7.22042 16.125,-16.125c0,-6.76533 0,-39.82158 0,-46.58333z"
                                ></path>
                            </g>
                        </g>
                    </svg>
                </div>
                <div class="w-100 p-3">
                    <h5>Total Exported</h5>
                    <h4 class="mb-0">
                        <div
                            v-if="!loaded"
                            class="spinner-border"
                            role="status"
                        >
                            <span class="sr-only">Loading...</span>
                        </div>
                        <template v-else>
                            {{ tally.total_exported.toLocaleString() }}
                        </template>
                    </h4>
                </div>
            </div>
        </b-col>

        <b-col class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4">
            <div
                class="analytics-widget-mini rounded d-flex align-items-center"
                :class="{ shadow: !isExport }"
                style="background-color: #2ecc71"
            >
                <div class="flex-shrink-1 darken-20 p-full">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="64"
                        height="36"
                        viewBox="0 0 172 172"
                        style="fill: #000000"
                    >
                        <g transform="">
                            <g
                                fill="none"
                                fill-rule="nonzero"
                                stroke="none"
                                stroke-width="1"
                                stroke-linecap="butt"
                                stroke-linejoin="miter"
                                stroke-miterlimit="10"
                                stroke-dasharray=""
                                stroke-dashoffset="0"
                                font-family="none"
                                font-weight="none"
                                font-size="none"
                                text-anchor="none"
                                style="mix-blend-mode: normal"
                            >
                                <path
                                    d="M0,172v-172h172v172z"
                                    fill="none"
                                ></path>
                                <g id="original-icon" fill="#ffffff">
                                    <path
                                        d="M146.37917,47.55442l-65.53917,65.53917c-1.04633,1.04992 -2.42233,1.57308 -3.79833,1.57308c-1.376,0 -2.752,-0.52317 -3.80192,-1.57308l-17.91667,-17.91667c-2.09983,-2.09983 -2.09983,-5.50042 0,-7.60025c2.09983,-2.09983 5.50042,-2.09983 7.60025,0l14.11475,14.11475l62.81583,-62.81583c-13.14367,-15.007 -32.38617,-24.54225 -53.85392,-24.54225c-39.517,0 -71.66667,32.14967 -71.66667,71.66667c0,39.517 32.14967,71.66667 71.66667,71.66667c39.517,0 71.66667,-32.14967 71.66667,-71.66667c0,-14.15058 -4.17817,-27.32292 -11.2875,-38.44558z"
                                    ></path>
                                </g>
                                <path
                                    d="M79.98,92.02v-12.04h12.04v12.04z"
                                    fill="none"
                                ></path>
                                <path
                                    d="M83.42,88.58v-5.16h5.16v5.16z"
                                    fill="none"
                                ></path>
                                <path
                                    d="M80.84,91.16v-10.32h10.32v10.32z"
                                    fill="none"
                                ></path>
                                <path
                                    d="M84.28,87.72v-3.44h3.44v3.44z"
                                    fill="none"
                                ></path>
                                <path
                                    d="M79.12,92.88v-13.76h13.76v13.76z"
                                    fill="none"
                                ></path>
                                <path
                                    d="M82.56,89.44v-6.88h6.88v6.88z"
                                    fill="none"
                                ></path>
                                <path
                                    d="M5.16,166.84v-161.68h161.68v161.68z"
                                    fill="none"
                                ></path>
                                <path
                                    d="M8.6,163.4v-154.8h154.8v154.8z"
                                    fill="none"
                                ></path>
                                <path
                                    d="M0.86,171.14v-170.28h170.28v170.28z"
                                    fill="none"
                                ></path>
                                <path
                                    d="M4.3,167.7v-163.4h163.4v163.4z"
                                    fill="none"
                                ></path>
                                <path
                                    d="M0,172v-172h172v172z"
                                    fill="none"
                                ></path>
                                <path
                                    d="M3.44,168.56v-165.12h165.12v165.12z"
                                    fill="none"
                                ></path>
                                <path
                                    d="M0.86,171.14v-170.28h170.28v170.28z"
                                    fill="none"
                                ></path>
                                <path
                                    d="M4.3,167.7v-163.4h163.4v163.4z"
                                    fill="none"
                                ></path>
                                <path
                                    d="M51.6,120.4v-68.8h68.8v68.8z"
                                    fill="none"
                                ></path>
                                <path
                                    d="M55.04,116.96v-61.92h61.92v61.92z"
                                    fill="none"
                                ></path>
                                <path
                                    d="M64.5,107.5v-43h43v43z"
                                    fill="none"
                                ></path>
                                <path
                                    d="M67.94,104.06v-36.12h36.12v36.12z"
                                    fill="none"
                                ></path>
                                <path
                                    d="M73.1,98.9v-25.8h25.8v25.8z"
                                    fill="none"
                                ></path>
                                <path
                                    d="M76.54,95.46v-18.92h18.92v18.92z"
                                    fill="none"
                                ></path>
                                <path d="" fill="none"></path>
                                <path d="" fill="none"></path>
                            </g>
                        </g>
                    </svg>
                </div>
                <div class="w-100 p-3">
                    <h5>Pass Rate</h5>
                    <h5 class="mb-0">
                        <div
                            v-if="!loaded"
                            class="spinner-border"
                            role="status"
                        >
                            <span class="sr-only">Loading...</span>
                        </div>
                        <template v-else>
                            {{
                                tally.pass_rate.toLocaleString(undefined, {
                                    maximumFractionDigits: 2,
                                })
                            }}%
                        </template>
                    </h5>
                </div>
            </div>
        </b-col>

        <b-col class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4">
            <div
                class="analytics-widget-mini rounded d-flex align-items-center"
                :class="{ shadow: !isExport }"
                style="background-color: #f39c12"
            >
                <div class="flex-shrink-1 darken-20 p-full">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="64"
                        height="36"
                        viewBox="0 0 172 172"
                        style="fill: #000000"
                    >
                        <g
                            fill="none"
                            fill-rule="nonzero"
                            stroke="none"
                            stroke-width="1"
                            stroke-linecap="butt"
                            stroke-linejoin="miter"
                            stroke-miterlimit="10"
                            stroke-dasharray=""
                            stroke-dashoffset="0"
                            font-family="none"
                            font-weight="none"
                            font-size="none"
                            text-anchor="none"
                            style="mix-blend-mode: normal"
                        >
                            <path d="M0,172v-172h172v172z" fill="none"></path>
                            <g fill="#ffffff">
                                <path
                                    d="M45.01563,14.78125c-9.675,0 -17.46875,7.79375 -17.46875,17.46875v107.5c0,9.675 7.79375,17.46875 17.46875,17.46875h81.96875c9.675,0 17.46875,-7.79375 17.46875,-17.46875v-107.5c0,-9.675 -7.79375,-17.46875 -17.46875,-17.46875zM45.01563,22.84375h81.96875c5.24062,0 9.40625,4.16563 9.40625,9.40625v107.5c0,5.24062 -4.16563,9.40625 -9.40625,9.40625h-81.96875c-5.24063,0 -9.40625,-4.16563 -9.40625,-9.40625v-107.5c0,-5.24062 4.16562,-9.40625 9.40625,-9.40625zM81.96875,41.65625v12.09375h-12.09375v8.0625h12.09375v12.09375h8.0625v-12.09375h12.09375v-8.0625h-12.09375v-12.09375zM50.39063,98.09375c-2.28438,0 -4.03125,1.74688 -4.03125,4.03125c0,2.28437 1.74687,4.03125 4.03125,4.03125h68.53125c2.28437,0 4.03125,-1.74688 4.03125,-4.03125c0,-2.28437 -1.74688,-4.03125 -4.03125,-4.03125zM50.39063,118.25c-2.28438,0 -4.03125,1.74688 -4.03125,4.03125c0,2.28437 1.74687,4.03125 4.03125,4.03125h35.60938c2.28437,0 4.03125,-1.74688 4.03125,-4.03125c0,-2.28437 -1.74688,-4.03125 -4.03125,-4.03125z"
                                ></path>
                            </g>
                        </g>
                    </svg>
                </div>
                <div class="w-100 p-3">
                    <h5>Saved Products</h5>
                    <h4 class="mb-0">
                        <div
                            v-if="!loaded"
                            class="spinner-border"
                            role="status"
                        >
                            <span class="sr-only">Loading...</span>
                        </div>
                        <template v-else>
                            {{ tally.saved_count.toLocaleString() }}
                        </template>
                    </h4>
                </div>
            </div>
        </b-col>
    </b-row>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "Tally",
  props: {
    isExport: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loaded: false
    };
  },
  computed: {
    ...mapGetters({
      tally: "analytics/getTallyStatsData"
    }),
    ...mapState("analytics", {
      tallyLoading: state => state.loading.tallyStats,
      start_date: state => state.start_date,
      end_date: state => state.end_date,
      unit: state => state.unit
    })
  },
  mounted() {
    if (this.isExport) {
      this.loaded = true;
    }

    if (!this.isExport) {
      this.fetchTally().then(r => {
        this.loaded = true;
      });

      this.$root.$on("tallySt", () => {
        this.reRender();
      });
    }
  },

  methods: {
    ...mapActions({
      getTallyStats: "analytics/getTallyStats"
    }),
    fetchTally() {
      this.loaded = false;
      return this.getTallyStats({
        start_date: this.start_date,
        end_date: this.end_date,
        unit: this.unit
      }).then(() => {
        this.loaded = true;
      });
    },
    reRender() {
      this.fetchTally().then(r => {
        this.loaded = true;
      });
    }
  }
};
</script>

<style scoped>
.p-full {
  padding: 30px 0px;
}
</style>
